import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador, Funcionario, Secretaria, Secretario, SolicitacaoAjustePonto, SolicitacaoFerias, StatusSolicitacao } from '../../api.service';
import { ModalPortariaFeriasComponent } from '../ferias/modal-portaria-ferias.component';
import { ModalSolicitacaoFeriasComponent } from '../ferias/modal-solicitacao-ferias.component';
import { ServicoPortariaFerias } from '../ferias/servico-portaria-ferias';
import { ServicoFuncionarioAdministrativo } from '../funcionario/servico-funcionario-administrativo';
import { ServicoSolicitacaoAdministrativa } from './servico-solicitacao-administrativa';

@Component({
  selector: 'app-tela-solicitacoes',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalPortariaFeriasComponent, ModalSolicitacaoFeriasComponent],
  templateUrl: './tela-solicitacoes.component.html'
})
export class TelaSolicitacoesComponent implements OnChanges {
  @Input() tipo: 'ajustes' | 'ferias' = 'ajustes';
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() mensagem = new EventEmitter<string>();
  @Output() atualizarResumo = new EventEmitter<void>();

  @ViewChild(ModalPortariaFeriasComponent) modalPortaria?: ModalPortariaFeriasComponent;

  status: StatusSolicitacao = 'PENDENTE';
  parecer = '';
  ajustes: SolicitacaoAjustePonto[] = [];
  ferias: SolicitacaoFerias[] = [];
  secretarias: Secretaria[] = [];
  secretarios: Secretario[] = [];
  modalAberta = false;
  modalPedidoAberta = false;
  salvandoPedido = false;
  salvandoPortaria = false;
  solicitacaoPortaria: SolicitacaoFerias | null = null;
  funcionarios: Funcionario[] = [];

  constructor(
    private readonly servico: ServicoSolicitacaoAdministrativa,
    private readonly servicoFuncionario: ServicoFuncionarioAdministrativo,
    readonly servicoPortaria: ServicoPortariaFerias
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado'] || changes['tipo']) {
      this.recarregar();
    }
  }

  get titulo() {
    return this.tipo === 'ferias' ? 'Gerenciador Férias' : 'Ajustes de ponto';
  }

  rotuloStatus(status: StatusSolicitacao) {
    return this.servico.rotuloStatus(status);
  }

  formatarData(valor?: string) {
    return this.servicoPortaria.formatarData(valor);
  }

  alterarEmpregador(empregadorId: string) {
    this.empregadorSelecionadoChange.emit(empregadorId);
  }

  recarregar() {
    if (!this.empregadorSelecionado) {
      this.ajustes = [];
      this.ferias = [];
      this.secretarias = [];
      this.secretarios = [];
      this.funcionarios = [];
      return;
    }
    if (this.tipo === 'ferias') {
      this.carregarCadastrosPortaria();
      this.carregarFuncionarios();
      this.servico.listarFerias(this.empregadorSelecionado, this.status).subscribe({
        next: ferias => this.ferias = ferias,
        error: () => this.mensagem.emit('Nao foi possivel carregar as solicitacoes de ferias.')
      });
      return;
    }
    this.servico.listarAjustes(this.empregadorSelecionado, this.status).subscribe({
      next: ajustes => this.ajustes = ajustes,
      error: () => this.mensagem.emit('Nao foi possivel carregar as solicitacoes de ajuste.')
    });
  }

  decidirAjuste(item: SolicitacaoAjustePonto, deferida: boolean) {
    this.servico.decidirAjuste(item.id, deferida, this.parecer).subscribe({
      next: () => {
        this.parecer = '';
        this.mensagem.emit(deferida
          ? 'Solicitacao deferida. A marcacao foi gravada na folha oficial.'
          : 'Solicitacao indeferida.');
        this.recarregar();
        this.atualizarResumo.emit();
      },
      error: erro => this.mensagem.emit(erro?.error?.detail || 'Nao foi possivel decidir a solicitacao.')
    });
  }

  abrirPedidoFerias() {
    this.carregarFuncionarios();
    this.modalPedidoAberta = true;
  }

  fecharPedidoFerias() {
    this.modalPedidoAberta = false;
    this.salvandoPedido = false;
  }

  enviarPedidoFerias(dados: { funcionarioId: string; dataInicio: string; dataFim: string }) {
    this.salvandoPedido = true;
    this.servico.pedirFerias(dados.funcionarioId, dados.dataInicio, dados.dataFim).subscribe({
      next: salva => {
        this.salvandoPedido = false;
        this.modalPedidoAberta = false;
        this.status = 'PENDENTE';
        this.mensagem.emit(`Solicitação ${salva.protocolo} gravada para ${salva.matricula} - ${salva.nome}.`);
        this.recarregar();
        this.atualizarResumo.emit();
      },
      error: erro => {
        this.salvandoPedido = false;
        this.mensagem.emit(erro?.error?.detail || 'Nao foi possivel solicitar as ferias.');
      }
    });
  }

  rotuloOrigem(item: SolicitacaoFerias) {
    return item.solicitadoPor || 'Portal';
  }

  abrirDeferimento(item: SolicitacaoFerias) {
    this.solicitacaoPortaria = item;
    this.modalAberta = true;
    this.carregarCadastrosPortaria();
  }

  fecharModalPortaria() {
    this.modalAberta = false;
    this.solicitacaoPortaria = null;
    this.salvandoPortaria = false;
  }

  decidirFerias(item: SolicitacaoFerias, deferida: boolean) {
    if (deferida) {
      this.abrirDeferimento(item);
      return;
    }
    this.servicoPortaria.decidirFerias(item.id, false, this.parecer).subscribe({
      next: () => {
        this.parecer = '';
        this.mensagem.emit('Ferias indeferidas.');
        this.recarregar();
        this.atualizarResumo.emit();
      },
      error: erro => this.mensagem.emit(erro?.error?.detail || 'Nao foi possivel decidir a solicitacao.')
    });
  }

  salvarPortaria(dados: { secretariaId: string; periodoAquisitivo: string; dataInicio: string; dataFim: string }) {
    if (!this.solicitacaoPortaria) {
      return;
    }
    this.salvandoPortaria = true;
    this.servicoPortaria.decidirFerias(this.solicitacaoPortaria.id, true, this.parecer, dados).subscribe({
      next: salva => {
        this.salvandoPortaria = false;
        this.parecer = '';
        this.mensagem.emit(`Portaria nº ${salva.portariaNumero}/${salva.portariaAno} gravada.`);
        this.modalPortaria?.marcarSalva(salva);
        this.atualizarResumo.emit();
        this.recarregar();
      },
      error: erro => {
        this.salvandoPortaria = false;
        this.mensagem.emit(erro?.error?.detail || 'Nao foi possivel deferir as ferias.');
      }
    });
  }

  exportarPortaria(item: SolicitacaoFerias) {
    this.servicoPortaria.baixarPortariaObservable(item.id).subscribe({
      next: blob => this.servicoPortaria.baixarBlob(blob, this.servicoPortaria.nomeArquivo(item.portariaNumero, item.portariaAno)),
      error: erro => this.mensagem.emit(erro?.error?.detail || 'Nao foi possivel exportar a portaria.')
    });
  }

  private carregarFuncionarios() {
    if (!this.empregadorSelecionado) {
      this.funcionarios = [];
      return;
    }
    this.servicoFuncionario.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: funcionarios => this.funcionarios = funcionarios,
      error: () => this.funcionarios = []
    });
  }

  private carregarCadastrosPortaria() {
    if (!this.empregadorSelecionado) {
      return;
    }
    this.servicoPortaria.listarSecretarias(this.empregadorSelecionado).subscribe({
      next: secretarias => this.secretarias = secretarias,
      error: () => this.secretarias = []
    });
    this.servicoPortaria.listarSecretarios(this.empregadorSelecionado).subscribe({
      next: secretarios => this.secretarios = secretarios,
      error: () => this.secretarios = []
    });
  }
}
